import {system} from "@/server";
import {messageHdl, msgCode} from "@/tools/messageHdlr";

export default {
  data() {
    return {
      captchaData: {
        id: "",
        image: ""
      },
      refreshCaptchaAt: null,
    }
  },
  methods: {
    getCaptchaInfo() {
      this.loginForm.captchaText = "";
      system.initCaptcha(this).then(({queryCaptchaInfo: resp = {}}) => {
        if (resp.code === 0) {
          const {id, image} = resp.data || {};
          this.captchaData.id = id;
          this.captchaData.image = image;
        }
        this.$refs.loginForm.clearValidate();
      }).catch(err => {
        console.log(err)
      })
    },
    refreshCaptcha() {
      if (this.refreshCaptchaAt && (Date.now() - this.refreshCaptchaAt) < 1000) {
        messageHdl.call(this, {code: msgCode.WARNING, msg: "图形验证码获取频繁！"});
        return
      }
      this.refreshCaptchaAt = Date.now();
      this.getCaptchaInfo()
    },
  }
}
